// Mirayama "In motion" switch (sections/mm-film-switch.liquid).
// One switch above the pair chooses the poncho; both frames crossfade together.
// Only the visible pair plays, and only while on screen, in a visible tab and without
// prefers-reduced-motion (then the posters stay). Hidden films stay paused and are not
// loaded (preload="none") until they are first chosen. A Pause / Play button under the pair
// stops both films (WCAG 2.2.2).
if (!customElements.get('mm-film-switch')) {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  customElements.define(
    'mm-film-switch',
    class MmFilmSwitch extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-fs-set]'));
        this.layers = Array.from(this.querySelectorAll('[data-fs-layer]'));
        this.captions = Array.from(this.querySelectorAll('[data-fs-cap]'));
        this.index = 0;
        this.inView = !('IntersectionObserver' in window);

        this.layers.forEach((layer) => {
          const video = layer.querySelector('video');
          if (video) {
            video.muted = true;
            video.playsInline = true;
          }
        });

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.select(parseInt(button.dataset.fsSet, 10)));
        });

        this.userPaused = false;
        this.pauseButton = this.querySelector('[data-fs-pause]');
        if (this.pauseButton && !reduceMotion.matches) {
          this.pauseButton.hidden = false;
          this.pauseButton.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.pauseButton.textContent = this.userPaused ? 'Play' : 'Pause';
            this.pauseButton.setAttribute('aria-label', this.userPaused ? 'Play the films' : 'Pause the films');
            this.update();
          });
        }

        this.onChange = () => this.update();
        document.addEventListener('visibilitychange', this.onChange);
        if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', this.onChange);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            ([entry]) => {
              this.inView = entry.isIntersecting;
              this.update();
            },
            { threshold: 0.1 }
          );
          this.observer.observe(this.querySelector('.mm-films__grid') || this);
        }
        this.update();
      }

      disconnectedCallback() {
        document.removeEventListener('visibilitychange', this.onChange);
        if (reduceMotion.removeEventListener) reduceMotion.removeEventListener('change', this.onChange);
        if (this.observer) this.observer.disconnect();
      }

      select(next) {
        if (Number.isNaN(next) || next === this.index) return;
        this.index = next;
        this.buttons.forEach((button) => {
          button.setAttribute('aria-pressed', parseInt(button.dataset.fsSet, 10) === next ? 'true' : 'false');
        });
        this.layers.forEach((layer) => {
          const on = parseInt(layer.dataset.fsLayer, 10) === next;
          layer.classList.toggle('is-active', on);
          if (on) {
            layer.removeAttribute('aria-hidden');
            const video = layer.querySelector('video');
            // Start the chosen pair together, from the first frame.
            if (video && video.readyState > 0) video.currentTime = 0;
          } else {
            layer.setAttribute('aria-hidden', 'true');
          }
        });
        this.captions.forEach((caption) => {
          caption.hidden = parseInt(caption.dataset.fsCap, 10) !== next;
        });
        this.update();
      }

      update() {
        const shouldPlay = this.inView && !reduceMotion.matches && !document.hidden && !this.userPaused;
        this.layers.forEach((layer) => {
          const video = layer.querySelector('video');
          if (!video) return;
          const active = parseInt(layer.dataset.fsLayer, 10) === this.index;
          if (active && shouldPlay) {
            if (video.preload === 'none') video.preload = 'auto';
            if (video.paused) {
              const playing = video.play();
              if (playing && playing.catch) playing.catch(() => {});
            }
          } else if (!video.paused) {
            video.pause();
          }
        });
      }
    }
  );
}
